export const querySelectorAsync = async (selector, parent, timeout) => {
  parent = parent || document
  let searchTimeout
  let timeoutObject
  const search = (resolve) => {
    const element = parent.querySelector(selector)
    if (element) {
      if (timeoutObject) {
        clearTimeout(timeoutObject)
      }
      resolve(element)
    }
    searchTimeout = setTimeout(() => search(resolve), 250)
  }
  return new Promise((resolve, reject) => {
    search(resolve)
    if (timeout) {
      timeoutObject = setTimeout(() => {
        if (searchTimeout) {
          clearTimeout(searchTimeout)
        }
        reject()
      }, timeout)
    }
  })
}

export default {
  querySelectorAsync
}
